export const transformObjectToDataGridRowsArray = (obj) => {
    return Object.entries(obj).map(([key, value]) => ({
        ...value,
        id: key,
    }));
};
